import { render } from "./Licences.vue?vue&type=template&id=58372a03"
import script from "./Licences.vue?vue&type=script&lang=js"
export * from "./Licences.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__